import { HTMLAttributes } from "react";
import styled from "styled-components";
import { designSystemVars as vars } from "../tokens";

export type SurfaceTone = "default" | "subtle";
export type SurfacePadding = "none" | "sm" | "md" | "lg";
export type SurfaceRadius = "none" | "sm" | "md" | "lg";

export interface SurfaceProps extends HTMLAttributes<HTMLDivElement> {
  tone?: SurfaceTone;
  padding?: SurfacePadding;
  radius?: SurfaceRadius;
  bordered?: boolean;
  elevated?: boolean;
}

const paddingValues = {
  none: vars.spacing.none,
  sm: vars.spacing.sm,
  md: vars.spacing.lg,
  lg: vars.spacing.xl,
};

const radiusValues = {
  none: vars.radius.none,
  sm: vars.radius.sm,
  md: vars.radius.md,
  lg: vars.radius.lg,
};

const surfaceProps = ["tone", "padding", "radius", "bordered", "elevated"];

export const Surface = styled.div
  .withConfig({
    shouldForwardProp: (prop) => !surfaceProps.includes(prop),
  })
  .attrs<SurfaceProps>(({ role }) => ({
    role,
  }))<SurfaceProps>`
  box-sizing: border-box;
  padding: ${({ padding = "none" }: SurfaceProps) => paddingValues[padding]};
  border: ${({ bordered = false }) =>
    bordered
      ? `${vars.borderWidth.thin} solid ${vars.color.border.subtle}`
      : "none"};
  border-radius: ${({ radius = "none" }: SurfaceProps) => radiusValues[radius]};
  background: ${({ tone = "default" }) =>
    tone === "subtle"
      ? vars.color.background.subtle
      : vars.color.background.surface};
  box-shadow: ${({ elevated = false }) => (elevated ? vars.shadow.sm : "none")};
  color: ${vars.color.text.primary};
`;

export const Card = styled(Surface).attrs<SurfaceProps>(({ as, ...props }) => ({
  as: as || "article",
  bordered: props.bordered ?? true,
  padding: props.padding || "md",
  radius: props.radius || "md",
}))``;
